import React from "react";

export default function Content({ children }) {
  return (
    <section className="container max-w-full sm:px-0 mx-auto mb-2">
      {children}
    </section>
  );
}
